<template>
  <div class="containerMod">
    <div v-if="loading" class="loading-container">
      <div class="loader"></div>
    </div>
    <div v-else>
      <div class="bloqueEdicion" v-for="tesis in tesisY" :key="tesis._id">
          <div>
            <div class="tipoDoc">{{tipoDoc(tesis.tipoDoc)}}</div>
            <div class="area">{{area(tesis.area)}}</div>
          </div>
          <div class="contenido">
            <div class="linea1">
              {{tesis.titulo}}
            </div>
            <div class="linea2">
              {{tesis.autores.map((ele) => `${ele.nombre} ${ele.apellidos}`).join(', ')}}
            </div>
            <div class="linea3">
              {{tesis.institucion}}
              {{tesis.ciudad ? (' | ' + tesis.ciudad) : `` }}
              {{tesis.pais ? (' - ' + tesis.pais) : `` }}
            </div>
            <div class="linea3">
              {{tesis.paginas > 0 ? (tesis.paginas + ' págs.') : `` }}
              {{tesis.size ? (tesis.size + 'mm') : ``}}
            </div>
            <div class="linea3">
              {{tesis.papel ? 'Edición papel' : (tesis.digital ? 'Edición digital' : ``)}}
              {{tesis.papel ? (tesis.digital ? ' | ' + 'Versión digital' : ``) : `` }}
              {{tesis.idioma ? (' | ' + tesis.idioma) : ``}}
            </div>
            <div class="linea4">
              <div class="lineaResumen">
                <p class="resumen">Resumen</p>
                <p class="up" @click="verResumen(tesis._id)" v-show="!resumenesVisibles.some(e => e === tesis._id)">&dtrif;</p>
                <p class="down" v-show="resumenesVisibles.some(e => e === tesis._id)" @click="ocultarResumen(tesis._id)">&utrif;</p>
              </div>
              <p v-show="resumenesVisibles.some(e => e === tesis._id)">{{tesis.resumen}}</p>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
export default {
  name: 'ShowTesisY',
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.getTesisY()
  },
  // emits: ['scrollHidden', 'NoScrollHidden'],
  data () {
    return {
      tesisY: [],
      aislar: false,
      resumenesVisibles: [],
      desplegado: true,
      URLbase: '',
      loading: false,
      meses:
        ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio',
          'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      areas: ['Antropoespeleología', 'Bioespeleología', 'Geoespeleología', 'Otras'],
      tipoDocs: ['Tesis', 'Seminario', 'Trabajo', 'Informe técnico', 'Monografía', 'Otro']
    }
  },
  methods: {
    async getTesisY () {
      try {
        this.loading = true
        const url = `${this.URLbase}/tesisY/getTesisY`
        const res = await fetch(url)
        this.tesisY = await res.json()
        this.loading = false
      } catch (error) {
        alert(error)
        this.loading = false
      }
    },

    mes (numMes) {
      return this.meses[numMes - 1]
    },
    area (numArea) {
      return this.areas[numArea - 1]
    },
    tipoDoc (tipo) {
      return this.tipoDocs[tipo - 1]
    },
    verResumen (ID) {
      this.resumenesVisibles.push(ID)
      this.desplegado = !this.desplegado
    },
    ocultarResumen (ID) {
      this.resumenesVisibles = this.resumenesVisibles.filter(e => e !== ID)
      this.desplegado = !this.desplegado
    }
  }
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.containerMod {
  overflow-y: auto;
  height: 99.9%;
  width: 100%;
  margin-top: 3px;
  background-color: var(--gr-fo-for);
  color:rgb(2, 2, 2);
}
.nombre{
  font-family: SegoeBI;
  color: rgb(1, 56, 82);
  padding-left: 4px;
  padding-top: 4px;
}
.bloqueEdicion{
  margin-top: 10px;
  padding-bottom: 1px;
  display: grid;
  grid-template-columns: 26% 70%;
}
.area{
  /* width: 120px;
  height: 170px; */
  font-size: 80%;
  color: white;
  background-color: rgb(59, 133, 186);
  border-radius: 4px;
  box-shadow: rgb(87, 85, 85) 5px 5px 7px;
  margin: 0px 12%;
  padding-bottom:2px;
}
.tipoDoc{
  font-size: 80%;
  color: white;
  background-color: rgb(58, 120, 170) ;
  border-radius: 4px;
  box-shadow: rgb(87, 85, 85) 5px 5px 7px;
  margin: 0px 12%;
  padding-bottom:2px;
}
.contenido{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 10px;
  border-bottom: solid 0.5px rgb(136, 166, 180);
  padding-bottom: 25px;
  margin-bottom: 0px;
}
.linea1{
  text-align: left;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: 16px;
  color: rgb(30, 119, 161);
}
.linea2{
  font-size: 14px;
  font-weight:700;
}
.linea3{
  font-size: 14px;
  text-align: left;
}
.linea4{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  white-space: pre-line;
  color:rgb(1, 56, 82)
}
.linea4 p{
  text-align: left;
}
.lineaResumen{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.resumen{
  font-weight: bold;
  font-size: 16px;
  color: rgb(30, 119, 161);
}
.up, .down{
  cursor:pointer;
  font-size: 30px;
}
.selector, .retorno{
  color: rgb(0, 137, 200);
  font-size: 20px;
  font-weight: bolder;
  cursor: pointer;
  height: 16px;
  width: 16px;
  align-self: center;
  padding-bottom: 8px;
}
.loading-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.loader {
  border: 4px solid transparent;
  border-top-color: #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  margin: auto;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
@media screen and (max-width: 576px){
  .containerMod{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .bloqueFicha{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%
  }
 .restoDatos{
    width: 100%;
    border-bottom: none;
  }
  .linea1, .linea2, .linea3, .linea4{
    text-align: left;
    padding-left: 15px;
    padding-right: 15px;
  }
  .linea2{
    /* font-size: 14px; */
    margin-top: 6px;
    margin-bottom: 6px;
    font-weight: 700;
}
  .containerEdiciones{
    width: 90%;
  }
  .bloqueEdicion{
    display: flex;
    flex-direction: column;
  }
  .tipoDoc{
  width: 60%;
  font-size: 100%;
  font-weight: 700;
  border: solid 1.5px gray;
  color: rgb(30, 119, 161);
  background-color: var(--gr-fo-for);
  margin: 0px auto;
  padding-bottom:2px;
  box-shadow: none;
}
  .area{
    width: 60%;
    /* height: 170px; */
    font-size: 100%;
    padding-bottom:2px;
    margin-right: auto;
    margin-left: auto;
    margin-bottom:13px;
    margin-top: 5px;
    box-shadow: none;
  }
  .up, .down{
    margin:  2px 4px 0;
  }
}
</style>
